import React from 'react';

/**
 * Renders a spanning header row used to label a group of rows.
 * Internal component — use ReactTableWrapper instead.
 * @param {object} props
 * @param {React.ReactNode} props.children - Header content
 * @param {number} props.colSpan - Number of columns this header spans
 * @returns {React.ReactElement}
 */
export const RowGroupHeader = ({ children, colSpan }) => {
  return (
    <div role='row'>
      <div aria-colspan={colSpan} role='columnheader'>
        {children}
      </div>
    </div>
  );
};
